module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/collect-data/collect-data.component.css
// module id = ./src/app/modules/boxoffice-module/components/collect-data/collect-data.component.css
// module chunks = 9